export default __webpack_public_path__ + "media/images/ad_landing_page/Disney-75c0ec0a90587ca929dd6aea1433e712.png";